import i18n from "../i18n";

const getLang = () => i18n.language.split("-")[0];

const normalizeProduct = (product) => {
  if (!product) return product;
  const normalized = { ...product };
  if (normalized.name && typeof normalized.name === "object") {
    normalized.name = Object.values(normalized.name)[0] || "";
  }
  if (normalized.short_description && typeof normalized.short_description === "object") {
    normalized.short_description = Object.values(normalized.short_description)[0] || "";
  }
  return normalized;
};

const mapProducts = (data) => {
  if (Array.isArray(data)) return data.map(normalizeProduct);
  return normalizeProduct(data);
};

export const Woo = {
  domain: {
    hello: async () => {
      return fetch(process.env.REACT_APP_API_HOST + "/api/hello").then((res) =>
        res.json()
      );
    },
  },
  categories: {
    all: async () => {
      return fetch(
        `${process.env.REACT_APP_API_HOST}/api/products/categories?lang=${getLang()}`
      ).then((res) => res.json());
    },
  },
  products: {
    all: async () => {
      return fetch(
        `${process.env.REACT_APP_API_HOST}/api/products?lang=${getLang()}`
      ).then((res) => res.json()).then(mapProducts);
    },
    findByCategory: async (category, options = {}) => {
      const lang = getLang();
      return fetch(
        `${process.env.REACT_APP_API_HOST}/api/products${category ? `?category=${category}&lang=${lang}` : `?lang=${lang}`
        }`, options
      ).then((res) => res.json()).then(mapProducts);
    },
    findBy: async (criteria) => {
      criteria.lang = getLang();
      return fetch(
        `${process.env.REACT_APP_API_HOST}/api/products?` +
        new URLSearchParams(criteria)
      ).then((e) => e.json()).then(mapProducts);
    },
    find: async (slug) => {
      const lang = getLang();
      return fetch(
        `${process.env.REACT_APP_API_HOST}/api/product${slug ? `?slug=${slug}&lang=${lang}` : `?lang=${lang}`
        }`
      ).then((res) => res.json()).then(mapProducts);
    },
  },
  orders: {
    all: async (customer) => {
      return fetch(process.env.REACT_APP_API_HOST + "/api/orders", {
        headers: { "X-Customer-Token": customer },
      }).then((res) => res.json());
    },
    find: async (customer, id) => {
      return fetch(`${process.env.REACT_APP_API_HOST}/api/orders/${id}`, {
        headers: { "X-Customer-Token": customer },
      }).then((res) => res.json());
    },
  },
  coupons: {
    get: async (code) => {
      return fetch(`${process.env.REACT_APP_API_HOST}/api/coupons?coupon_code=${code}`, {
      }).then((res) => res.json());
    },
  },
  customers: {
    post: async (user) => {
      return fetch(process.env.REACT_APP_API_HOST + "/api/customers", {
        method: "POST",
        body: JSON.stringify(user),
      });
    },
    put: async (id, user) => {
      return fetch(process.env.REACT_APP_API_HOST + "/api/customers/" + id, {
        method: "PUT",
        body: JSON.stringify(user),
      }).then((data) => data.json());
    },
    shippingAddresses: {
      all: async (customer) => {
        return fetch(process.env.REACT_APP_API_HOST + "/api/customers/addresses", {
          headers: { "X-Customer-Token": customer },
        }).then((res) => res.json());
      },
      post: async (customer, address) => {
        return fetch(process.env.REACT_APP_API_HOST + "/api/customers/addresses", {
          method: "POST",
          headers: { "X-Customer-Token": customer },
          body: JSON.stringify(address),
        }).then((res) => res.json());
      },
      delete: async (customer, id) => {
        return fetch(process.env.REACT_APP_API_HOST + "/api/customers/addresses/" + id, {
          method: "DELETE",
          headers: { "X-Customer-Token": customer },
        }).then((res) => res.json());
      },
    },
  },
};

export function createWooProduct(data) {
  return {
    product: {
      id: data.id,
      name: data.name,
      type: data.type,
      bundle: data.bundledItems,
      quantity: data.quantity,
      variation: data.variation,
      price: data.price,
    },
  };
}
